import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

export function LoadingSpinner({
  size = 'md',
  className = '',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={cn('flex justify-center items-center', className)} aria-hidden="true">
      <Loader2 className={cn(sizeClasses[size], 'animate-spin text-primary')} />
    </div>
  );
}
